import { render, staticRenderFns } from "./SearchBoxUserAddresses.vue?vue&type=template&id=c9c15fb2&scoped=true"
import script from "./SearchBoxUserAddresses.vue?vue&type=script&lang=js"
export * from "./SearchBoxUserAddresses.vue?vue&type=script&lang=js"
import style0 from "./SearchBoxUserAddresses.vue?vue&type=style&index=0&id=c9c15fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c15fb2",
  null
  
)

export default component.exports